import { render, staticRenderFns } from "./TotalizerCorrectionsTab.vue?vue&type=template&id=44ae5ed0&"
import script from "./TotalizerCorrectionsTab.vue?vue&type=script&lang=ts&"
export * from "./TotalizerCorrectionsTab.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports